import actions from '../../actionTypes';

export default workflow => {
  return {
    type: actions.ADDED_WORKFLOW,
    workflow
  };
};



// WEBPACK FOOTER //
// ./src/reducers/workflows/actions/addedWorkflow.js